var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadtype3NewJewelry1Upd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type3_x5F_jewelry:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31__x5F_upd_4_"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    fill: "#3A2310",
    enableBackground: "new    ",
    d: "M247.4,299.8c-0.6,0.4-0.4,1.7,0.5,1.7L247.4,299.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFEAB5",
    d: "M248.7,299.9c-0.8-0.8-1.8-0.3-1.4,0.6c1,2.8,1.4,6.3,1.4,10.4c0,8.4-2.4,15.3-5.4,15.3 s-5.4-6.8-5.4-15.3c0-4.4,0.6-8.3,1.7-11.1l-0.4-0.4c-2.3,3.4-3.7,9-3.7,15.8c0,10.5,3.7,18.9,8.3,18.9s8.3-8.5,8.3-18.9 C252.2,308.9,250.9,303.3,248.7,299.9z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M249.8,324.2c-0.8,2.7-2.5,4.7-4.4,6.4c-1.6,1.7-4.2,1.4-5.5-0.9c0.8,2.3,3.9,4,6.1,1.8 C248.4,329.4,249,326.8,249.8,324.2L249.8,324.2z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    fill: "#3A2310",
    enableBackground: "new    ",
    d: "M472.3,299.1c0.6,0.4,0.4,1.7-0.5,1.7L472.3,299.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFEAB5",
    d: "M470.9,299.2c0.8-0.8,1.8-0.3,1.4,0.6c-1,2.8-1.4,6.3-1.4,10.4c0,8.4,2.4,15.3,5.4,15.3s5.4-6.8,5.4-15.3 c0-4.4-0.6-8.3-1.7-11.1l0.4-0.4c2.3,3.4,3.7,9,3.7,15.8c0,10.5-3.7,18.9-8.3,18.9c-4.6,0-8.4-8.5-8.4-18.9 C467.4,308.3,468.8,302.7,470.9,299.2z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M469.9,323.5c0.8,2.7,2.5,4.7,4.5,6.4c1.6,1.7,4.2,1.4,5.5-0.9c-0.8,2.3-3.9,4-6.1,1.8 C471.2,328.7,470.6,326.2,469.9,323.5L469.9,323.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadtype3NewJewelry1Upd);
export default __webpack_public_path__ + "static/media/headtype3-new_jewelry_1_upd.c3c7bdf59a9c897f01bcd2bf76a31acc.svg";
export { ForwardRef as ReactComponent };